<div class="d-flex m-auto flex-row justify-content-center align-items-center">
  <div class="row">
    <div class="container m-t justify-content-center">
      <div id="maintenance-page">
        <p>
          <img class="cal-logo" src="../../assets/images/logo/cal-logo-2x.png" />
        </p>
        <h1>We'll be back soon!</h1>
        <p>
          <br />

          We'll be back online shortly!
          <br />
          <br />
          Sorry for the inconvenience. we are making upgrades to provide <br />
          our customers with a better experience.‎
        </p>
      </div>
    </div>
  </div>
</div>
